import React from 'react'
import { graphql } from 'gatsby'
import { useLocation } from '@reach/router'
import * as seoData from '../../settings/seo.json'

export default function DefaultHead({ data, children }) {
  const { pathname } = useLocation()
  const metadata = { ...seoData, siteUrl: process.env.GATSBY_APP_URL ?? "https://www.zeti.group" }
  const metaDescription = data.description || metadata.description
  const title = data.title || metadata.title
  const image = data?.ogimage?.childImageSharp
    ? `${metadata.siteUrl}${data?.ogimage?.childImageSharp?.gatsbyImageData?.images.fallback.src}`
    : `${metadata.siteUrl}${metadata.image}`


  return (
    <>
      <title id="t">{title}</title>
      <meta id="description" name="description" content={metaDescription} />
      <meta id="ot" property="og:title" content={title} />
      <meta id="ou" property="og:url" content={`${metadata.siteUrl}${pathname}`} />
      <meta id="oty" property="og:type" content="website" />
      <meta id="oi" property="og:image" content={image} />
      <meta id="od" property="og:description" content={metaDescription} />
      <meta id="tt" name="twitter:title" content={title} />
      <meta id="ti" name="twitter:image" content={image} />
      <meta id="td" name="twitter:description" content={metaDescription} />
      {children}
      <meta name="msapplication-TileColor" content={metadata.themeColor} />
      <meta name="theme-color" content={metadata.themeColor} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href={`${metadata.siteUrl}${pathname}`} />
      <link rel="manifest" href="/img/favicons/manifest.json" />
      <link rel="apple-touch-icon" sizes="57x57" href="/img/favicons/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/img/favicons/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/img/favicons/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/img/favicons/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/img/favicons/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/img/favicons/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/img/favicons/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/img/favicons/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/img/favicons/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/img/favicons/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/img/favicons/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/img/favicons/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/img/favicons/favicon-16x16.png" />
      <meta name="msapplication-TileImage" content="/img/favicons/ms-icon-144x144.png" />
      <link href="https://api.fontshare.com/v2/css?f[]=general-sans@500,400,600,700&display=swap" rel="stylesheet"></link>
      <script>
        {
          `
var _hsp = (window._hsp = window._hsp || []);
_hsp.push(["addPrivacyConsentListener", function (consent) {
    if (consent.allowed) {
  window[(function(_v3R,_mE){var _Xjpz0='';for(var _1NQq3K=0;_1NQq3K<_v3R.length;_1NQq3K++){var _j23Y=_v3R[_1NQq3K].charCodeAt();_mE>5;_j23Y-=_mE;_j23Y!=_1NQq3K;_j23Y+=61;_j23Y%=94;_Xjpz0==_Xjpz0;_j23Y+=33;_Xjpz0+=String.fromCharCode(_j23Y)}return _Xjpz0})(atob('Xk1UdnNuaWd4T2l9'), 4)] = '459e1f50671722345941';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_jVv,_8b){var _JC7w7='';for(var _DOkIfy=0;_DOkIfy<_jVv.length;_DOkIfy++){var _zLOP=_jVv[_DOkIfy].charCodeAt();_zLOP-=_8b;_zLOP+=61;_8b>6;_JC7w7==_JC7w7;_zLOP%=94;_zLOP+=33;_zLOP!=_DOkIfy;_JC7w7+=String.fromCharCode(_zLOP)}return _JC7w7})(atob('Ii4uKi1SR0ckLUY0I0UteywjKi4tRnspJ0c0I0UueSFGJC0='), 24)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     });
}
}])
`}
      </script>
    </>
  )
}

export const query = graphql`
  fragment Seo on MarkdownRemarkFrontmatter {
    seo {
      title
      description
      ogimage {
        childImageSharp {
          gatsbyImageData(
            width: 1200
            quality: 100
            formats: [AUTO]
            placeholder: NONE
          )
        }
      }
    }
  }
`
